import { Button, Spacing } from '@vkontakte/vkui';
import React, { type FC, memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { aiImageGenerationPaidLimit } from 'reactApp/appHelpers/featuresHelpers/features/aiImageGeneration';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { getNextAiGenerationTime } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { sendXray } from 'reactApp/utils/ga';

import styles from './AiGenerationClamp.css';

interface Props {
    onClose: () => void;
}

export const AiGenerationClamp: FC<Props> = memo(function AiGenerationClamp({ onClose }) {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isCorpOrPaid = isPaidUser || isCorpUser;
    const time = getNextAiGenerationTime();

    useEffect(() => {
        sendXray(['ai-gen', 'clamp', 'show']);
    }, []);

    const handleOnClick = useCallback(() => {
        sendXray(['ai-gen', 'clamp', 'btn', 'click']);

        if (isCorpOrPaid) {
            onClose();
            return;
        }
    }, [onClose, isCorpOrPaid]);

    return (
        <div className={styles.wrapper}>
            <img src={`${cdnPackagesUrl}/static/cloud/ai/photo-generation/clamp/clamp-idle.gif`} draggable={false} className={styles.img} />
            <Spacing size={32} />
            <div className={styles.title}>
                {isCorpOrPaid
                    ? `Вы\u00A0сгенерировали ${aiImageGenerationPaidLimit}\u00A0изображений из\u00A0${aiImageGenerationPaidLimit}`
                    : `${aiImageGenerationPaidLimit}\u00A0генераций в\u00A0день с\u00A0подпиской Mail\u00A0Space`}
            </div>
            <Spacing size={24} />
            <div className={styles.subTitle}>
                {isCorpOrPaid
                    ? `Создать новое можно будет ${time ? `в ${time}` : 'через 24 часа'}`
                    : `Вы\u00A0сгенерировали изображение с\u00A0нейросетью бесплатно. Следующее можно\u00A0— ${
                          time ? `в ${time}` : 'через 24 часа'
                      }. А\u00A0с\u00A0подпиской\u00A0— сейчас`}
            </div>
            <Spacing size={42} />
            <Button mode="primary" appearance="accent-invariable" size="l" className={styles.button} onClick={handleOnClick}>
                {isCorpOrPaid ? 'Понятно' : 'Подключить за\u00A01\u00A0₽'}
            </Button>
        </div>
    );
});
